import styled from 'styled-components'
import { rgba } from 'polished'
import AvatarStack, {
  OverflowBadge,
} from 'modules/shares/components/AvatarStack'
import Avatar from 'components/Avatar'
import {
  HeadingContainer,
  VersionItemHeading,
} from 'components/VersionItem/VersionItemHeading'

export const Container = styled.div<{
  active?: boolean
}>`
  display: flex;
  align-items: center;
  height: 32px;
  margin: 0 4px 1px; /* stylelint-disable-line scales/space */
  padding: 0 16px;
  transition: color ${({ theme }) => theme.transitions.duration[1]},
    background-color ${({ theme }) => theme.transitions.duration[1]};
  border-radius: 3px;
  cursor: default;

  ${HeadingContainer} {
    color: ${({ theme }) => theme.colors.abbey};
  }
`

export const IconContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 17px;
  margin-right: 16px;
  flex-shrink: 0;
`

export const StyledAvatarStack = styled(AvatarStack)`
  /* Fix -4 px of margin in AvatarContainer */
  padding-right: 4px;

  ${OverflowBadge} {
    background-color: transparent;
    border: 2px solid ${({ theme }) => rgba(theme.colors.antiquebrass, 0.5)};
    color: #963c00;
    cursor: default;
    opacity: 0.9;
  }
`
interface StackedAvatarProps {
  zIndex: number
}

export const StackedAvatar = styled(Avatar)`
  z-index: ${({ zIndex }: StackedAvatarProps) => zIndex};
`

export const StyledVersionHeading = styled(VersionItemHeading)`
  margin-left: 8px;
`
